import React from 'react';

import styled  from 'styled-components';


export default function BottomConfirmModal({visible,zIndex=600,title, description,onCancel, onComplete}) { 
    return (
        <>
            {(visible === true) &&(
                <ModalWrapper zIndex={zIndex}>
                    <ModalSection>
                        {(title && (<ModalHeader>{title}</ModalHeader>))}
                        {(description && (<ModalBody>{description}</ModalBody>))} 
                        <ButtonSection>
                            <ModalBtn onClick={()=>{if(onCancel)onCancel()}}>취소</ModalBtn>
                            <BtnSpacer></BtnSpacer>
                            <ConfirmBtn onClick={()=>{if(onComplete)onComplete()}}>완료</ConfirmBtn>
                        </ButtonSection>
                    </ModalSection>
                </ModalWrapper>
            )} 
        </>
    )
}

const ModalWrapper = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: flex-end; 
    background: rgba(0,0,0,0.5);
    z-index: ${(props) => props.zIndex};

`

const ModalSection = styled.div`
    padding : calc(100vw * (23 / 375)) calc(100vw * (16 / 375)) calc(100vw * (13 / 375)) calc(100vw * (16 / 375));
    background : white;
    position:absolute;
    bottom : 0;
    left:0;
    right: 0;
    margin: auto;
    border-radius: calc(100vw * (15 / 375)) calc(100vw * (15 / 375)) 0px 0px;
`
const ModalHeader = styled.div`
    text-align: center;
    white-space: pre-wrap;
    margin-bottom : calc(100vw * (14 / 375));

    font-style: normal;
    font-weight: 700;
    font-size: calc(100vw * (18 / 375)); 
    color: #000000; 
`

const ModalBody = styled.div`
    text-align: center;
    white-space: pre-wrap;
    margin-bottom : calc(100vw * (27 / 375));
    font-style: normal;
    font-weight: 400;
    font-size: calc(100vw * (16 / 375)); 
    line-height: calc(100vw * (23 / 375));
    text-align: center; 
    color: #000000;
`

const ButtonSection = styled.div`
    display: flex;
    justify-content: space-between;
    position: relative;
`
const ModalBtn = styled.div`
    font-style: normal;
    font-weight: 700;
    font-size: calc(100vw * (16 / 375));
    color: #121212;

    width : 100%;
    text-align :center;
    background: #F7F7F7;
    border-radius: calc(100vw * (5 / 375));

    padding: calc(100vw * (16 / 375)) 0;
`

const ConfirmBtn = styled(ModalBtn)`
    background: #FFCF19;
`

const BtnSpacer = styled.div`
    width : calc(100vw * (13 / 375));
`